<template>
  <div id="task-asset">
    <div class="col-md-4 image">
      <!-- <a :href="downloadHref" download="download" v-if="isImage && downloadHref"> -->
      <a @click="downloadItem(asset.url)"  v-if="isImage">
        <div class="asset image" :style="{'background-image': `url('${asset.url}')`}"></div>
      </a>
      <a target="_blank" :href="asset.url" v-if="isAudio">
        <div class="asset audio">
          <i class="fa fa-music"></i>
          &nbsp;
          {{asset.file_name}}
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from 'axios';

export default {
  name: "TaskAsset",
  components: {},
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      downloadHref: '',
    };
  },
  created() {

  },
  mounted() {
    var canvas = document.createElement("canvas");

    const image = new Image();
    image.crossOrigin="Anonymous"
    image.src= this.asset.url;
    const context = canvas.getContext('2d');
    const main = this
    image.onload = function() {
      context.drawImage(image, 0, 0, image.width, image.height);
      main.downloadHref = canvas.toDataURL("image/png");
    }

  },
  computed: {
    isImage() {
      return this.asset.content_type.includes("image");
    },
    isAudio() {
      return this.asset.content_type.includes("audio");
    }
  },
 methods: {
  downloadItem (url) {
    axios.get(url, { responseType: 'blob' })
      .then(({ data }) => {
        const blob = new Blob([data], { type: 'image/png' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `${this.asset.file_name}`
        link.click()
      }).catch(error => console.error(error))
    }
  },
  watch: {}
};
</script>

<style lang="scss">
#task-asset {
  .asset {
    width: 70%;
    &.image,
    &.audio {
      height: 200px;
      width: 200px;
      background-size: cover;
      border-radius: 4px;
      margin: 10px auto;
    }
    &.audio {
      background-color: #fbfbfb;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 10px;
      text-align: center;
      word-wrap: break-word;
      flex-direction: column;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/tasks/TaskAsset.vue